import styled, { css } from "styled-components";

const LoyaltyIndicatorBoxWrapper = styled.div`
  ${props => {
    if (!props.isMobile) {
      return css`
        width: 200px;
        height: 45px;
        margin-bottom: 10px;
      `;
    } else {
      return css`
        width: 100%;
        margin-bottom: 2rem;
      `;
    }
  }}
  display: flex;
  flex-direction: row;
`;

const LoyaltyContent = styled.div`
  width: 100%;
  ${props => {
    if (!props.isMobile && !props.isLoaded) {
      return css`
        width: 0 !important;
        height: 0 !important;
        margin: 0 !important;
        padding: 0 !important;
      `;
    }
  }}
`;

export { LoyaltyIndicatorBoxWrapper, LoyaltyContent };
